/** Interlettrage bloc texte — valeur en em (0 = normal). */
export function resolveTextLetterSpacingEm(props) {
  const raw = props?.letterSpacing;
  if (raw === undefined || raw === null || raw === '') return null;
  const n = Number(raw);
  if (!Number.isFinite(n)) return null;
  if (Math.abs(n) < 0.0001) return null;
  return n;
}

export function resolveTextBlockTypographyStyle(props) {
  const em = resolveTextLetterSpacingEm(props);
  if (em == null) return {};
  return { letterSpacing: `${em}em` };
}
